import { Button, Field, FieldLabel, Input } from "@forge/ui";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Flame } from "lucide-react";
import { useState } from "react";
import { api, unwrap } from "../lib/api";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");

  const forgot = useMutation({
    mutationFn: async () =>
      unwrap(await api.auth["forgot-password"].post({ email })),
  });

  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface p-4">
      <div className="w-full max-w-xs">
        <div className="mb-8 flex flex-col items-center gap-3">
          <Link
            to="/"
            className="flex size-10 items-center justify-center rounded-surface bg-ember text-ink-inverse shadow-raised"
          >
            <Flame className="size-5" />
          </Link>
          <div className="text-center">
            <h1 className="text-lg font-semibold tracking-tight text-ink">
              Esqueci a senha
            </h1>
            <p className="text-2xs text-ink-muted">
              Se o e-mail existir, enviamos um link que vale por 1 hora.
            </p>
          </div>
        </div>

        {forgot.isSuccess ? (
          <p className="rounded-control border border-success/25 bg-success-subtle px-3 py-2 text-2xs text-success">
            Se houver uma conta neste e-mail, o link já foi enviado.
          </p>
        ) : (
          <form
            className="flex flex-col gap-4"
            onSubmit={(event) => {
              event.preventDefault();
              forgot.mutate();
            }}
          >
            <Field>
              <FieldLabel>E-mail</FieldLabel>
              <Input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="voce@empresa.com.br"
              />
            </Field>
            <Button type="submit" size="lg" loading={forgot.isPending}>
              Enviar link
            </Button>
          </form>
        )}

        <p className="mt-6 text-center text-2xs text-ink-muted">
          <Link to="/login" className="text-ink underline-offset-2 hover:underline">
            Voltar ao login
          </Link>
        </p>
      </div>
    </div>
  );
}
